import { useAtomValue } from 'jotai';

import { type AtomState } from '@/ui/utilities/state/jotai/types/AtomState';

export const useAtomStateValue = <TValue>(state: AtomState<TValue>) =>
  useAtomValue(state.atom);
